/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { TransactionAmount } from "./TransactionAmount";
import { Dettaglio } from "./Dettaglio";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const TransactionR = t.interface({
  amount: TransactionAmount,

  created: UTCISODateFromString,

  description: t.string,

  grandTotal: TransactionAmount,

  id: t.Integer,

  idPayment: t.Integer,

  idWallet: t.Integer,

  merchant: t.string,

  statusMessage: t.string
});

// optional attributes
const TransactionO = t.partial({
  accountingStatus: t.Integer,

  authorizationCode: t.string,

  detailsList: t.readonlyArray(Dettaglio, "array of Dettaglio"),

  directAcquirer: t.boolean,

  error: t.boolean,

  fee: TransactionAmount,

  idPsp: t.Integer,

  idStatus: t.Integer,

  nodoIdPayment: t.string,

  numAut: t.string,

  orderNumber: t.Integer,

  paymentCancelled: t.boolean,

  paymentModel: t.Integer,

  rrn: t.string,

  spcNodeDescription: t.string,

  spcNodeStatus: t.Integer,

  success: t.boolean,

  token: t.string,

  updated: UTCISODateFromString,

  urlCheckout3ds: t.string,

  urlRedirectPSP: t.string
});

export const Transaction = t.intersection(
  [TransactionR, TransactionO],
  "Transaction"
);

export type Transaction = t.TypeOf<typeof Transaction>;
